import { colors2 } from "oolib";
import { SIGNAL_CATEGORY_ACCENT } from "@/components/analysisModules/comps/SignalFilters/signalCategories";

/**
 * Presentation over the scores: tones, colours and the one-line texts the
 * surfaces print. The momentum WORDING itself comes from the server with
 * each item (momentumLabel) and scope (meta.basisText, meta.reasonText), so
 * the tooltip, the table, the cards and the read-out never disagree.
 */

export const severityText = (item) => item.severity.value.toFixed(2);

export const grainNoun = (grain) => (grain === "week" ? "weeks" : grain === "year" ? "years" : "months");

// The momentum wording the scorer attached to the item (okf-be
// priorities/format.js momentumLabelOf): `bare` is the form for a cell
// whose header names the comparison and whose arrow carries the direction.
export const momentumText = (item, { bare = false } = {}) => {
  const label = item.momentumLabel || {};
  return { arrow: label.arrow || "·", text: (bare ? label.bareText : label.text) || "no momentum", tone: label.tone || "muted", reason: label.reason };
};

// The colour a momentum tone reads in: rising risk in the dissatisfaction
// accent, cooling in the satisfaction one, flat / muted grey.
export const toneColor = (tone) =>
  tone === "up" ? SIGNAL_CATEGORY_ACCENT.userDissatisfaction : tone === "down" ? SIGNAL_CATEGORY_ACCENT.userSatisfaction : colors2.grey50;
// Wins invert the tone: rising praise is good, cooling praise is the warning.
export const winTone = (tone) => (tone === "up" ? "down" : tone === "down" ? "up" : tone);
export const zoneKeyOf = (item) => (item.isWin ? "win" : item.zone || "none");

// "3 calls" / "3 sources" — distinct documents, named by dataset when they
// all come from one.
export const sourcesText = (item, titleByContentType = {}) => {
  const docs = item.severity.docs;
  if (item.datasets.length === 1) {
    const title = titleByContentType[item.datasets[0]] || item.datasets[0];
    return `${docs} × ${title}`;
  }
  return `${docs} source${docs === 1 ? "" : "s"} · ${item.datasets.length} datasets`;
};
